import { patternListChoices } from "../../../helper/tools";

export default function LastNameForm({ onChange, value, required, ref }) {
    const handleChange = (e) => {
        e.target.value = e.target.value.trim().toUpperCase();
        onChange(e);
    };

    return (
        <div className="form-input">
            <label htmlFor="lastName" className={required && "required"}>Nom</label>
            <input
                pattern={patternListChoices?.lastname}
                ref={ref}
                type="text"
                name="lastName"
                defaultValue={value}
                onChange={handleChange}
                onBlur={handleChange}
                required={required}
            />
        </div>
    )
}